import { useContext, useEffect } from 'react'
import { CurrentHeaderContext } from 'core/contexts/CurrentHeaderContext'

export const useDebugHeader = () => {
  const { setHeader } = useContext(CurrentHeaderContext)

  useEffect(() => {
    setHeader({
      svgPath: 'logoIaDocs.svg',
      svgPathDark: 'logoIaDocsDark.svg',
      accroche: 'iadocs.debug.accroche',
      column: true,
    })
  }, [setHeader])
}

export const readPositiveInt = (
  value: string | null,
  fallback: number,
  max?: number
) => {
  const parsed = Number(value)
  if (!Number.isInteger(parsed) || parsed < 1) {
    return fallback
  }
  if (max && parsed > max) {
    return max
  }
  return parsed
}

export const readListParam = (params: URLSearchParams, key: string) => {
  return [...params.getAll(`${key}[]`), ...params.getAll(key)]
    .map((value) => value.trim())
    .filter((value) => value !== '')
}

export const readTextParam = (params: URLSearchParams, key: string) => {
  const value = params.get(key)?.trim() ?? ''
  return value === '' ? null : value
}
